import React, { useCallback } from 'react';

import BackButton from 'components/BackButton';
import { useNavigate } from 'react-router-dom';

const GoBackButton = (): JSX.Element => {
  const navigate = useNavigate();

  const handleBackClick = useCallback((): void => {
    navigate(-1);
  }, [navigate]);

  return <BackButton handleOnClick={handleBackClick} />;
};

export default GoBackButton;
